import { Controller } from "stimulus";

export default class extends Controller {
    connect() {        
        // Read the date from data attribute (following the pattern used in other controllers)
        const dateString = this.element.dataset.countdownDate || this.element.getAttribute('data-countdown-date');
                
        if (!dateString) {
            console.error('Countdown timer: countdownDate value is required');
            return;
        }

        this.countdownDate = new Date(dateString).getTime();
        
        if (isNaN(this.countdownDate)) {
            console.error('Countdown timer: Invalid date format:', dateString);
            return;
        }

        // Update immediately
        this.updateTimer();
        
        // Update every second
        this.intervalId = setInterval(() => this.updateTimer(), 1000);
    }

    disconnect() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    updateTimer() {
        const now = new Date().getTime();
        const distance = this.countdownDate - now;

        if (distance < 0) {
            // Timer has expired
            this.element.querySelectorAll(".number").forEach(num => {
                num.textContent = "0";
            });
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const numbers = this.element.querySelectorAll(".number");
        
        if (numbers.length >= 4) {
            numbers[0].textContent = days.toString().padStart(2, '0');
            numbers[1].textContent = hours.toString().padStart(2, '0');
            numbers[2].textContent = minutes.toString().padStart(2, '0');
            numbers[3].textContent = seconds.toString().padStart(2, '0');
        } else {
            console.error('Countdown timer: Expected 4 number elements, found:', numbers.length);
        }
    }
}

